import { ORDER_STATUS } from '../../../../../types/orders';
import { STATUS_VARIANTS, statusVariants } from 'components/NudosComponents/BordStatus/BordStatus.type';

interface ICurrentOrderStatusDisplay {
  label: string;
  variant: statusVariants;
}

const ORDER_STATUS_DISPLAY_MAP: Record<ORDER_STATUS, ICurrentOrderStatusDisplay> = {
  [ORDER_STATUS.DELIVERED]: { label: 'Entregado', variant: STATUS_VARIANTS.success },
  [ORDER_STATUS.CANCELLED]: { label: 'Cancelado', variant: STATUS_VARIANTS.danger },
  [ORDER_STATUS.ACTIVE]: { label: 'Activo', variant: STATUS_VARIANTS.informative },
  [ORDER_STATUS.PENDING]: { label: 'Por confirmar', variant: STATUS_VARIANTS.default }
};

/**
 * Obtiene objeto con el estado actual de la orden y su variante a renderizar en el componente BordStatus
 * @param statusName - El estado actual de la orden
 * @returns Objeto con el estado actual de la orden y su variante a renderizar
 */
export const getCurrentStatusDisplay = (statusName: ORDER_STATUS): ICurrentOrderStatusDisplay => {
  return ORDER_STATUS_DISPLAY_MAP[statusName] || ORDER_STATUS_DISPLAY_MAP[ORDER_STATUS.PENDING];
};
